import React from 'react'
import VirtualCardsYourCards from 'src/app/VirtualCardsYourCards/VirtualCardsYourCards'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { virtualCardsYourCardsRouteProps } from 'src/navigation/routeProps'

const VirtualCardsYourCardsAppRoute: AppRoute = {
  routeProps: virtualCardsYourCardsRouteProps,
  component: <VirtualCardsYourCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardsYourCardsAppRoute
